module.exports = __webpack_public_path__ + "img/dcmm_4.34642e5d.png";